export default "__VITE_ASSET__DO6bA$Kt__"